const images = {
  logo: require("./assets/logo.png"),
  background_video: require("./assets/background-video.mp4"),
};

export default images;
